module.exports = new __parcel__URL__("walletio.7403da40.svg").toString();